<template>
  <div></div>
</template>

<script>
import { OauthParameter } from "@/utils/index";
import { setToken } from "@/utils/auth";

export default {
  name: "oatuh",
  created() {
    this.fetchOAuth();
  },
  methods: {
    fetchOAuth() {
      const code = OauthParameter("code");
      this.$store
        .dispatch("fetchOAuthCertification", code)
        .then(res => {
          if (res && res.code == 200) {
            this.SetToken(res.data.token);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    SetToken(token) {
      this.$store.dispatch("SetToken", token);
        this.$router.push("/manage");
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/views/oauth/index.vue